import { withComponentDefaults } from "@whitespace/components";
import PropTypes from "prop-types";
import React from "react";

import { WPContentNodeCard } from "../../../../../../../../plugins/@whitespace/gatsby-theme-wordpress-basic/src/components";

PostsModuleIndexItem.propTypes = {
  item: PropTypes.object,
};

export default withComponentDefaults(
  PostsModuleIndexItem,
  "postsModuleIndexItem",
);

function PostsModuleIndexItem({
  // dateFormat = {
  //   year: "numeric",
  //   month: "numeric",
  //   day: "numeric",
  // },
  item,
  ...restProps
}) {
  return <WPContentNodeCard contentNode={item} {...restProps} />;
}
